// extracted by mini-css-extract-plugin
var _1 = "EpostFormCalculateLoader-moduleEpostFormCalculateLoader__ol6z1";
var _2 = "EpostFormCalculateLoader-moduleloader__fOc6A";
var _3 = "EpostFormCalculateLoader-moduletext__hy9am";
export { _1 as "EpostFormCalculateLoader", _2 as "loader", _3 as "text" }
